import { render, staticRenderFns } from "./GenericControlsView.vue?vue&type=template&id=8db35b1c&"
import script from "./GenericControlsView.vue?vue&type=script&lang=js&"
export * from "./GenericControlsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports